
if(process.env.VUE_APP_RUNTIME_ENVIRONMENT === 'development'){
    module.exports = require('./development-routes.js');
} else {
    module.exports = require('./production-routes.js');
}
